<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import AuthApi from "@/services/auth-api";
import Vue from 'vue'

import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import UsersApi from "@/services/users-api";

/**
 * Login component
 */
export default {
  page: {
    title: "Authentification",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, NprogressContainer, FormWizard, TabContent,WizardStep },
  data() {
    return {
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,

      forgetPasswordisClicked:false,
      createNewAccountClicked:false,

      newPassword:"",
      confPassword:"",
      username:"",
      errorMessage:"",
      showErrorMesage:false,
      tryingToCreateCode:false,
      code:"",
      showSecondErrorMessage:false,
      secondErrorMessage:"",

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,

      passwordHidden: true,
    };
  },

  computed:{
    getPrimaryColor(){
      return   process.env.VUE_APP_PRIMARY_COLOR;
    }

  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;
      // Reset the authError if it existed.
      this.authError = null;
      return (
        this.logIn({
          email: this.email,
          password: this.password
        })
          // eslint-disable-next-line no-unused-vars
          .then(token => {
            this.tryingToLogIn = false;
            this.isAuthError = false;

            // Redirect to the originally requested page, or to the home page
            if (this.$route.query.redirectFrom == "/logout") {
              this.$router.push({ name: "default" });
            } else {
              this.$router.push(
                /*this.$route.query.redirectFrom ||*/ { name: "default" }
            );
            }
          })
          .catch(error => {

            this.tryingToLogIn = false;
            this.authError = error ? error : "";
            this.isAuthError = true;

            Vue.prototype.$snotify.error(this.authError);
          })
      );
    },

    openForgetPassword(){
      this.forgetPasswordisClicked=true
      this.newPassword=""
      this.confPassword=""
      this.username=""
      this.errorMessage=""
      this.showErrorMesage=false
      this.tryingToCreateCode=false
      this.code=""
      this.showSecondErrorMessage=false
      this.secondErrorMessage=""
      this.isAuthError=false
    },

    openCreateNewAccount() {
      this.createNewAccountClicked=true
    },

    _handleError(error) {
        this.errorMessage=error
        this.showErrorMesage=true
    },

    _handleSecondError(error) {
        this.secondErrorMessage=error
        this.showSecondErrorMessage=true
    },

    createCode () {

      return new Promise((resolve, reject) => {
          AuthApi.createCode(this.username,this.newPassword,this.confPassword)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleError(error));
          });
      });
    },

    resetPassword () {
      return new Promise((resolve, reject) => {
          AuthApi.resetPassword(this.username,this.code)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleSecondError(error));
          });
      });
    },

    addAccountRequest() {
        UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(
              (result) => {
                  if (result) {
                    Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
                    this.newAccountCompanyName = null;
                    this.newAccountCompanyPhone = null;
                    this.createNewAccountClicked=false;
                  }
              }
            ).finally(()=>{
            })
      },

  },

  mounted() {
      document.body.style.background='##fff';
  }
};
</script>



<template>
  <Layout class="nprogress-container">
      <nprogress-container></nprogress-container>

      <div class="row">
        <div class="col-md-6 d-md-inline d-none bg-auth " style="opacity:0.55;"></div>
        <div class="col-md-6 col-12 ">

          <div class="card overflow-hidden auth pt-5" style="opacity: 1;
    background-color: #fbfbfd !important;">

            <div class="row p-4 pt-5">
              <div class="col-lg-12 col-md-0 text-center">
                <router-link to="/" >
                  <img src="@/assets/images/demo/logo.png" alt height="100" />
                </router-link>
              </div>
            </div>


            <div v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="row pr-4 mt-1 pt-4 pl-4">
              <div class="col-12 text-right">
                <div class="text-primary pr-2 pl-0 pb-2">
                  <h5 class="text-primary font-weight-bold text-uppercase font-size-20 text-center">Plateforme de commande en ligne dédiée aux pharmaciens</h5>
                  <h5 class="text-dark font-size-16 text-center">Connectez-vous avec votre email et mot de passe <sup>*</sup></h5>
                </div>
              </div>
            </div>

            <div class="pt-0 pb-1 mt-0 auth-page-70-width " >
                
                <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

                <!-- PASSWORD REINIT -->
                <div v-if="forgetPasswordisClicked && !createNewAccountClicked" >

                  <div  class="row  mt-1 pt-4 ">
                  <div class="col-12 text-right">
                    <div class="text-primary pr-2 pl-0 pb-2">
                      <h5 class="text-primary font-weight-bold font-size-20 text-center">Mot de passe oublié ?</h5>
                      <h5 class="text-dark font-size-16 text-center">Suivez les étapes ci-dessous pour le réinitialiser
                      </h5>

                      

                    </div>
                  </div>
                </div>

                  <form-wizard  class="mt-4" :color="getPrimaryColor"  nextButtonText="Suivant" finish-button-text="Terminer" @on-complete="forgetPasswordisClicked=false">
                      <div slot="prev" scope="props" class="d-none">                      
                      </div>
                      <template slot="step" slot-scope="props">
                        <wizard-step :tab="props.tab"
                        :transition="props.transition"
                        
                        :index="props.index">
                        </wizard-step>
                      </template>
                    <tab-content icon="mdi mdi-account-circle"  :before-change="createCode">
                      <div class="row mb-4">
                        <div class="col-12">
                            <b-alert v-show="showErrorMesage" show variant="danger">{{this.errorMessage}}</b-alert>

                            <label class="mb-2" >Adresse Mail</label>
                            <input
                              class="form-control"
                              v-model="username"
                              type="text"
                              placeholder="Adresse Mail"
                              autocomplete="off"
                            />
                            <label class="mb-2 mt-4" for="pwd">Nouveau Mot de passe</label>
                            <input
                              class="form-control"
                              id="pwd"
                              v-model="newPassword"
                              type="password"
                              placeholder="Nouveau Mot de passe"
                              autocomplete="off"
                            />
                            <label class="mb-2 mt-4" for="confpwd">Retapez le nouveau mot de passe</label>
                            <input
                              class="form-control"
                              id="confpwd"
                              v-model="confPassword"
                              type="password"
                              placeholder="Mot de Passe de Confirmation"
                              autocomplete="off"
                            />
                        </div>
                      </div>
                    </tab-content>
                    <tab-content icon="mdi mdi-lock" :before-change="resetPassword" >
                      <div class="row">
                        <div class="col-12">
                            <b-alert v-show="showSecondErrorMessage" show variant="danger">{{this.secondErrorMessage}}</b-alert>
                            <div class="row mb-4">
                              <div class="col-12 text-center text-primary">
                              <i class="bx bx-hourglass bx-spin mr-2"></i>Un code a été envoyé à l'adresse <span class="font-weight-bold">{{this.username}}. </span> Ce code expire dans <span class="font-weight-bold">15 minutes</span>
                              </div>
                            </div>
                            <input
                              class="form-control mb-4"
                              v-model="code"
                              type="text"
                              placeholder="Saisir le Code"
                              autocomplete="off"
                            />
                        </div>
                      </div>
                    </tab-content>
                    <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                      <div class="row mb-4">
                        <div class="col-12">
                          <div class="text-center">
                            <h2 class="mt-0">
                              <i class="mdi mdi-check-all text-success"></i>
                            </h2>
                            <h3 class="mt-0">Félicitations !</h3>

                            <p class="w-75 mb-2 mx-auto">
                              Votre mot de passe a été réinitialisé avec succés.
                            </p>

                          </div>
                        </div>
                      </div>
                    </tab-content>
                  </form-wizard>
                  <div class="row">
                    <div class="col-12 text-dark text-center" >
                      <i class="mdi mdi-lock mr-1"></i> Vous vous en souvenez ?               
                        <div
                        style="cursor:pointer;"
                        @click="forgetPasswordisClicked=false"
                        class="font-weight-bold text-primary"
                        >Connectez-vous ici</div
                    > 
                    </div>
                  </div>
                </div>
                <!-- END PASSWORD REINIT -->

                <!-- PRO ACCOUNT CREATION -->
                <div v-if="!forgetPasswordisClicked && createNewAccountClicked" >
                  <div  class="row  mt-1 pt-4 ">
                  <div class="col-12 text-right">
                    <div class="text-primary pr-2 pl-0 pb-2">
                      <h5 class="text-primary text-uppercase font-weight-bold font-size-20 text-center">
                        <span >Créer un compte professionnel ?</span>
                      </h5>
                      <h5 class="text-dark font-size-16 text-center">Suivez les étapes ci-dessous pour le réinitialiser</h5>
                    </div>
                  </div>
                  </div>

                  <div class="row mt-4">
                              <div class="col-12">
                                <span class="text-secondary font-size-12" style="text-align:justify;">
                                  Envoyer nous le nom de votre société, votre numéro de téléphone ou adresse mail 
                                  et <u>demandez votre inscription à l'espace des clients professionnels.</u>
                                </span>
                              </div>
                          </div>

                  <b-form   class="pt-4 pb-2 pr-md-4 pr-0 pl-md-4 pl-0 mt-2" >
                  

                  <b-form-group class="text-dark mt-4" id="input-group-2"  label-for="input-2">

                    

                    <b-form-input
                    class="font-size-16 text-dark border border-dark"
                      
                      v-model="newAccountCompanyName"
                      placeholder="Nom de société"
                      autocomplete="off"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="text-dark" id="input-group-1"  label-for="input-1">
                    <b-form-input class="font-size-16 text-dark border border-dark" 
                          @keyup.native.enter="addAccountRequest()"
                          v-model="newAccountCompanyPhone"  placeholder="Numéro de Téléphone ou Adresse mail"></b-form-input>
                  </b-form-group>
                  
                  
                  <div class="mt-4">
                    <b-button  variant="primary" 
                    @click="addAccountRequest()"
                    class="btn-block font-weight-bold text-white font-size-20">Envoyer la demande</b-button>
                  </div>
                  <!-- <div class="mt-4 text-center text-info font-size-15">
                  </div> -->
                  
                </b-form>

                

                <div class="row mt-4">
                    <div class="col-12 text-dark text-center" >
                      <i class="mdi mdi-lock mr-1"></i> Vous avez déjà un compte ?               
                      <div
                      style="cursor:pointer;"
                      @click="createNewAccountClicked=false"
                      class="font-weight-bold text-primary"
                      >Connectez-vous ici</div
                    > 
                    </div>
                  </div>

                  
                </div>
                <!-- END PRO ACCOUNT CREATION -->

                <b-form  v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="pt-4 pb-2  pr-md-4 pr-0 pl-md-4 pl-0 mt-2" @submit.prevent="tryToLogIn">
                  <b-form-group class="text-dark" id="input-group-1"  label-for="input-1">
                    <b-form-input class="font-size-16 text-dark border border-dark" id="input-1" v-model="email" type="email" placeholder="Adresse mail"></b-form-input>
                  </b-form-group>

                  <b-form-group class="text-dark mt-4" id="input-group-2"  label-for="input-2">
                    <b-input-group >
                      <b-form-input
                      class="font-size-16 text-dark border border-dark"
                        id="input-2"
                        v-model="password"
                        :type="passwordHidden ? 'password':'text'"
                        placeholder="Mot de passe"
                        autocomplete="off"
                        style="border-right:0px !important;"
                      ></b-form-input>

                      <template v-slot:append>
                          <b-button  size="sm" variant="dark"  class="bg-white" style="border-left:0px !important;"  @click="passwordHidden = !passwordHidden"  >
                            <i :class="passwordHidden ?'fa fa-eye-slash text-dark':'display-eye fa fa-eye text-danger'"  ></i>
                          </b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                  <div class="mt-3 text-left">
                    <!-- <router-link tag="a" to="/forgot-password" class="text-muted"> -->
                    <div class="text-dark font-weight-bold" @click="openForgetPassword" style="cursor: pointer">
                      <i class="mdi mdi-lock mr-1"></i>Mot de passe oublié ?
                    </div>
                  </div>
                  
                  <div class="mt-4">
                    <b-button type="submit" variant="primary" class="btn-block font-weight-bold text-white font-size-20">Connecter</b-button>
                  </div>
                  <!-- <div class="mt-4 text-center text-info font-size-15">
                  </div> -->
                  
                </b-form>
                
                <p v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="pt-4  pr-md-4 pr-0 pl-md-4 pl-0 pb-0 font-size-11 text-muted" style="text-align:justify;">
                  
                  * Nous collectons des informations dans le but d'améliorer nos services et votre expérience lors de l'utilisation du site. 
                  En vous connectons vous acceptez les conditions d'utilisation du site.
                </p>

              

                <hr class="hr-text" data-content="OU" v-if="!forgetPasswordisClicked && !createNewAccountClicked"/>
            


              <div v-if="!forgetPasswordisClicked && !createNewAccountClicked" class="row pr-md-4 pl-md-4 mr-md-4 ml-md-4 ml-0 mr-0 mb-4">


                  <div class="col-12 text-center">

                      <b-button variant="outline-secondary" @click="openCreateNewAccount()" class="w-100" >
                          <span class=" font-weight-bold font-size-16" style="font-weight:600;">Demander un compte Professionnel</span>
                      </b-button>

                  </div>

                  
              </div>


          
            </div>

          </div>
        </div>
      </div>




  
  </Layout>
</template>




<style lang="scss" scoped>
  
  #nprogress .bar {
    background: $primary;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
    border: solid 4px transparent;
    border-top-color: $primary;
    border-left-color: $primary;
  }

  #nprogress .peg {
    box-shadow: 0 0 10px grey, 0 0 5px grey;
    opacity: 1.0;
  }


.bg-auth {
  background-image: url('~@/assets/images/demo/background/auth-back.jpg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  height: 1080px;
}

.auth {
  height: 1080px;
}

.auth-page-70-width{
  width: 70%;
  margin:auto;
}

@media (max-width: 768px) { /* Ajustez cette valeur selon votre besoin */
  .auth-page-70-width {
    width: 80%;
  }
}


</style>